"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1846],{

/***/ 78842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61097);
/* harmony import */ var data_locales_id_business_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38593);
/* harmony import */ var lib_gtag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5789);
/* harmony import */ var modules_Home_popupStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25803);






const ButtonScheduleDemo = ({ className ="" , id , variant , wrapperClass =""  })=>{
    const headingTranslationButton = data_locales_id_business_json__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx;
    const { showPopupFormSales  } = (0,modules_Home_popupStore__WEBPACK_IMPORTED_MODULE_5__/* .usePopupStoreFormSales */ .p)((state)=>({
            showPopupFormSales: state.showPopupFormSales
        }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `relative ${wrapperClass ?? ""}`,
        id: id,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: `flex justify-center items-center gap-8 !rounded-8 !text-b1 ${className}`,
            onClick: ()=>{
                (0,lib_gtag__WEBPACK_IMPORTED_MODULE_4__/* .pushDataLayer */ .zz)({
                    event: id
                });
                showPopupFormSales("");
            },
            variant: variant ?? "primary",
            isFull: variant ? true : false,
            children: headingTranslationButton.contactSales
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonScheduleDemo);


/***/ }),

/***/ 32836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ IconTrash; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);

const IconTrash = ({ size =24 , // color = "#19093A",
className ="fill-neutral-80"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z"
        })
    });
};


/***/ }),

/***/ 11846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageHeader_PageHeaderBusiness; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(61097);
// EXTERNAL MODULE: ./src/components/Button/ButtonScheduleDemo.tsx
var ButtonScheduleDemo = __webpack_require__(78842);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(47313);
// EXTERNAL MODULE: ./src/components/Chip/Chip.tsx
var Chip = __webpack_require__(5867);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(35824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./src/components/Icon/IconClose.tsx
var IconClose = __webpack_require__(84132);
// EXTERNAL MODULE: ./src/lib/device.ts
var device = __webpack_require__(59799);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 218 modules
var motion = __webpack_require__(32977);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(67832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/PageHeader/systemStore.ts
var systemStore = __webpack_require__(96937);
;// CONCATENATED MODULE: ./src/components/Drawer/index.tsx







const useOutsideClick = (callback)=>{
    const ref = react.useRef();
    react.useEffect(()=>{
        const handleClick = (event)=>{
            if (ref.current && !ref.current?.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return ()=>{
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        ref
    ]);
    return ref;
};
const Drawer = ({ isShow , isFullScreen , className , contentClassName , zIndex , contentStyles , contentWidth , title , onClose , onClickOutside , children , childrenClass , position ="right"  })=>{
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    const [theme] = (0,systemStore/* useSystemStore */.m)((state)=>[
            state.theme
        ]);
    const ref = useOutsideClick(()=>{
        if (onClickOutside) {
            onClickOutside();
        }
    });
    const classPosition = {
        right: [
            "w-full top-0 right-0 justify-end",
            "w-[25vw] 2xl-max:w-[35vw] rounded-l-16"
        ],
        bottom: [
            "inset-0 w-[100vw] justify-center",
            "w-[100vw] rounded-t-16"
        ],
        top: [
            "inset-0 w-[100vw] justify-start",
            "w-[100vw] rounded-b-16"
        ]
    };
    if (isShow) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
            initial: {
                opacity: 0
            },
            animate: isShow ? {
                opacity: 1
            } : {
                opacity: 0
            },
            style: {
                zIndex: zIndex || 9999,
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `fixed ${classPosition[position][0]} flex ${position == "top" ? "items-start" : "items-end"} bg-[#00000080] ${className || ""}`,
                    style: {
                        zIndex: zIndex || 9999
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: ref,
                        className: `relative bg-white py-[18px] p-[9px] ${classPosition[position][1]} overflow-auto ${isFullScreen ? `h-screen ` : ""} ${contentClassName || ""}`,
                        style: {
                            ...contentStyles
                        },
                        children: [
                            (title || onClose) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: `flex items-center pb-16 pl-[1px] pt-[7px]`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: theme == "dark" ? "/logo-white-2048.png" : "/logo-2048.png",
                                        alt: "learnext",
                                        width: 120,
                                        height: 21
                                    }),
                                    onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "ml-auto",
                                        onClick: onClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                                            size: 20,
                                            color: "#000000"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: childrenClass ?? "",
                                children: children
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: `
          html, body {
            overflow: hidden;
          }
        `
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var components_Drawer = (Drawer);

;// CONCATENATED MODULE: ./src/components/Icon/IconList.tsx

const IconList = ({ size =24 , color ="#551FC1"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Heroicons/Outline/menu",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Icon",
                d: "M4 6H20M4 12H20M4 18H20",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/InstantSearchBox/InstantSearchBox.tsx + 3 modules
var InstantSearchBox = __webpack_require__(57604);
// EXTERNAL MODULE: ./src/modules/Business/Selection/CartList.tsx + 1 modules
var CartList = __webpack_require__(13335);
// EXTERNAL MODULE: ./src/modules/Business/Selection/cartStore.ts
var cartStore = __webpack_require__(13084);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeaderBusiness.tsx















const PageHeaderBusiness = ({ isTransparent , useSearch =false  })=>{
    const router = (0,next_router.useRouter)();
    const [showDrawer, setShowDrawer] = (0,react.useState)(false);
    const [showMenu, setShowMenu] = (0,react.useState)(false);
    const currentCart = (0,cartStore/* useCartStore */.x)((state)=>state.currentCart);
    const [theme] = (0,systemStore/* useSystemStore */.m)((state)=>[
            state.theme
        ]);
    const [menus, setMenus] = (0,react.useState)([
        {
            label: "Benefit",
            href: "",
            anchor: "home-benefit"
        },
        {
            label: "Kursus",
            href: "",
            anchor: "home-access"
        },
        {
            label: "Paket",
            href: "",
            anchor: "home-packets"
        }
    ]);
    const isMobileView =  true && window.screen.width < 993;
    const handleScroll = (id)=>{
        setShowMenu(false);
        const elem = document.getElementById(id);
        if (!elem) return;
        const offset = -100;
        const y = elem.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    };
    const listAllowedHeaderBusiness = [
        "/",
        "/my-class",
        "/course/[courseSlug]",
        "/transactions/[transactionId]"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "w-full z-50 h-72 px-[12px] lg:px-[80px] bg-[#fff] sticky top-0 shadow-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
                className: "h-full flex items-center justify-between",
                useAuto: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center w-full gap-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-32 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: theme == "dark" ? "/logo-white-2048.png" : "/logo-2048.png",
                                        alt: "learnext",
                                        width: 120,
                                        height: 21
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex gap-32 hidden lg:block lg:flex",
                                    children: menus.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            //@ts-ignore
                                            onClick: ()=>handleScroll(a.anchor),
                                            className: "cursor-pointer font-medium text-black",
                                            children: a.label
                                        }, a.label))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "m-auto mr-0 sg-max:hidden",
                            children: !isTransparent && listAllowedHeaderBusiness.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                                className: "!h-40",
                                id: "cta-header"
                            })
                        }),
                        useSearch || !listAllowedHeaderBusiness.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-end gap-32 items-center",
                            children: [
                                useSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg-max:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearchBox/* default */.Z, {
                                        placeholder: "Search",
                                        position: "right",
                                        className: "w-400",
                                        theme: "transparent"
                                    })
                                }),
                                !listAllowedHeaderBusiness.includes(router.pathname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: `rounded-8 !p-8 hover-unset relative !border-0  ${currentCart.length > 0 ? "!bg-light_neutral10_to_dark_neutral50 hover:bg-light_neutral10_to_dark_neutral50" : "!bg-white hover:bg-white"}`,
                                    onClick: ()=>setShowDrawer(!showDrawer),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-violet_main_to_dark_purple_surface font-medium sm-max:text-c1",
                                            children: "Kursus Pilihanmu"
                                        }),
                                        currentCart.length > 0 && router.pathname !== "/cart/[id]" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "min-w-[20px] min-h-20 px-4 text-c2 flex items-center justify-center absolute text-white rounded-18 bg-red-50 right-0 top-0 translate-x-[40%] -translate-y-[30%]",
                                            children: currentCart.length
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden sg-max:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setShowMenu(!showMenu);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconList, {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Drawer, {
                isShow: showDrawer,
                isFullScreen: !isMobileView,
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-16",
                    children: [
                        "Kursus Pilihan",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chip/* Chip */.A, {
                            className: "bg-light_neutral10_to_dark_neutral50 text-violet_main_to_dark_purple_surface",
                            children: [
                                router.pathname === "/cart/[id]" ? 0 : currentCart.length,
                                " Kursus"
                            ]
                        })
                    ]
                }),
                onClose: ()=>setShowDrawer(false),
                childrenClass: "flex flex-col justify-between h-[95%]",
                position: isMobileView ? "bottom" : "right",
                children: [
                    router.pathname === "/cart/[id]" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                        title: "Kamu belum memilih kursus",
                        message: "Jelajahi kursus dan pilih kursus yang paling sesuai untuk perusahaanmu",
                        className: "!gap-16",
                        useButton: [
                            {
                                href: "/pilih-kursus",
                                label: "Pilih Kursus",
                                variant: "primary",
                                onClose: ()=>setShowDrawer(false)
                            }
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartList/* CartList */.A, {
                        className: currentCart.length ? "mb-16 !p-0 grid grid-cols-1 gap-16 max-h-[80vh] overflow-auto" : "h-[80vh]",
                        title: "",
                        onClose: ()=>setShowDrawer(false),
                        onClickButton: ()=>setShowDrawer(false),
                        wrapperList: "py-20 !pr-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "m-auto mb-0 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "w-full",
                            onClick: ()=>{
                                setShowDrawer(false);
                                //@ts-ignore
                                router.replace("/cart");
                            },
                            state: currentCart.length > 0 && router.pathname !== "/cart/[id]" ? "active" : "disabled",
                            children: "Lanjutkan"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Drawer, {
                isShow: showMenu,
                position: "top",
                onClose: ()=>setShowMenu(false),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-48 pt-[24px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-32",
                            children: menus.map((a)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: ()=>handleScroll(a.anchor),
                                    className: "cursor-pointer font-medium text-black",
                                    children: a.label
                                }, a.label))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonScheduleDemo/* default */.Z, {
                        className: "!h-40 w-full",
                        id: "cta-header"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageHeader_PageHeaderBusiness = (PageHeaderBusiness);


/***/ }),

/***/ 13335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ CartList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(47313);
// EXTERNAL MODULE: ./src/modules/Business/Selection/cartStore.ts
var cartStore = __webpack_require__(13084);
// EXTERNAL MODULE: ./src/components/Icon/IconPlayCircle.tsx
var IconPlayCircle = __webpack_require__(14016);
// EXTERNAL MODULE: ./src/components/Icon/IconStar.tsx
var IconStar = __webpack_require__(28939);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(99601);
// EXTERNAL MODULE: ./src/components/Icon/IconTrash.tsx
var IconTrash = __webpack_require__(32836);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(67832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Card/CardCourseHorizontal.tsx








const CardCourseHorizontal = ({ ...props })=>{
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-center w-full cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row w-[-webkit-fill-available] gap-8",
                children: [
                    props?.image_cover_url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "h-80 w-[140px] relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: props?.name,
                                src: props?.image_cover_url,
                                className: "object-cover object-center rounded-8",
                                width: 140,
                                height: 80
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute rounded-8 w-[140px] h-80 top-0 flex justify-center items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlayCircle/* IconPlayCircle */.U, {
                                    size: 32,
                                    classes: "m-auto",
                                    isBgCustomized: true
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-140 h-80 rounded-8 bg-neutral-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-fit 2xl-max:max-w-[calc(100%-148px)] justify-center gap-4 text-b2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-light line-clamp-1",
                                children: typeof props?.institution == "string" ? props?.institution.split("||")[0] || "" : props.institution.name || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `text-neutral-80 font-medium line-clamp-1 ${//  @ts-ignore
                                router.pathname === "/cart" ? "w-full" : "max-w-[168px]"}`,
                                children: props?.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-8 justify-start items-center font-light",
                                children: [
                                    typeof props?.review_summary?.star_avg === "number" && // @ts-ignore
                                    props?.review_summary?.star_avg !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStar/* IconStar */.G, {
                                                        size: 12,
                                                        fill: true,
                                                        color: "#EFB443"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-2",
                                                        children: (0,helper/* formatRating */.A6)(//  @ts-ignore
                                                        props?.review_summary?.star_avg.toFixed(1))
                                                    })
                                                ]
                                            }),
                                            "|"
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    props?.total_learners !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: `${(0,helper/* numberWithCommas */.x6)(props?.total_learners)} pelajar`
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            props.onDelete && router.pathname !== "/cart/[id]" && //@ts-ignore
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: props.onDelete,
                className: "m-auto mr-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* IconTrash */.I, {
                    color: "#817E8C"
                })
            })
        ]
    });
};
/* harmony default export */ var Card_CardCourseHorizontal = (CardCourseHorizontal);

;// CONCATENATED MODULE: ./src/modules/Business/Selection/CartList.tsx





const CartList = ({ className ="" , title , onClose , onClickButton , beforeInput , data , wrapperList  })=>{
    const { currentCart , updateCart  } = (0,cartStore/* useCartStore */.x)((state)=>({
            currentCart: state.currentCart,
            updateCart: state.updateCart
        }));
    let allData = data ?? currentCart;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `grid gap-16 ${className}`,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-h4 font-bold",
                children: title
            }),
            allData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `bg-white rounded-16 mb-16 grid grid-cols-1 gap-16 h-fit ${wrapperList ?? "p-20"}`,
                children: [
                    beforeInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: beforeInput
                    }),
                    allData.map((course, index)=>//@ts-ignore
                        /*#__PURE__*/ (0,react.createElement)(Card_CardCourseHorizontal, {
                            ...course,
                            index,
                            onDelete: ()=>updateCart(course),
                            key: Math.random()
                        }))
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-20 bg-white rounded-16 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                    title: "Kamu belum memilih kursus",
                    message: "Jelajahi kursus dan pilih kursus yang paling sesuai untuk perusahaanmu",
                    className: "!gap-16",
                    useButton: [
                        {
                            href: "/pilih-kursus",
                            label: "Pilih Kursus",
                            variant: "primary",
                            onClose: ()=>onClickButton()
                        }
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 25803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ usePopupStoreFormSales; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const usePopupStoreFormSales = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        isShow: false,
        currentCtaEvent: "",
        isShowYoutubeModal: false,
        // actions
        showPopupFormSales (event) {
            set({
                isShow: true,
                currentCtaEvent: event
            });
        },
        closePopupFormSales () {
            set({
                isShow: false
            });
        },
        showPopupYoutube () {
            set({
                isShowYoutubeModal: true
            });
        },
        closePopupYoutube () {
            set({
                isShowYoutubeModal: false
            });
        }
    }));


/***/ }),

/***/ 38593:
/***/ (function(module) {

module.exports = JSON.parse('{"fJ":{"title":"Tingkatkan Kompetensi Profesional dengan <strong class=\'text-violet_main whitespace-nowrap\'>AI Interaktif </strong>","description":"Bertanya, berdiskusi, dan mendapatkan feedback dengan <span class=\'font-[700]\'>AI real-time 24/7</span> untuk pengembangan kompetensi Anda, didukung <span class=\'font-[700]\'>1.000+ kursus</span> berkualitas dari perusahaan dan universitas ternama."},"yX":{"title":"Client Sudah Bergabung dengan Learnext"},"Yt":{"title":"Kenapa Perusahaan Memilih Learnext?","description":"Solusi Pembelajaran Profesional yang Cerdas, Skalabel, dan Siap Hadapi Masa Depan","content":[{"title":"Peningkatan Kompetensi Cerdas Berbasis AI","description":"Coach AI interaktif, penilaian dan feedback instan, dengan alur pembelajaran yang adaptif sesuai kebutuhan tiap profesional.","icon":"book","buttonDesc":"Coba AI","imageUrl":["/images/benefit-section-1-2.png","/images/benefit-section-1-1.png"],"imageAlt":"lms-content"},{"title":"Konversi Materi Perusahaan Menjadi Video Kursus Interaktif","description":"Konversi otomatis dari file PPT atau PDF ke video kursus dengan suara pengajar, kuis, dan tugas interaktif.","icon":"electric","buttonDesc":"Konversi Video","imageUrl":["/images/benefit-section-2-4.png","/images/benefit-section-3-2.png"],"imageAlt":"activity-team"},{"title":"Fleksibel, Terintegrasi, dan Tanpa Batas Pengguna","description":"Akses mudah 24 jam, terintegrasi dengan LMS atau sistem HR apa pun, dan bebas jumlah peserta tanpa biaya tambahan.","icon":"currency","buttonDesc":"Lihat Paket Biaya","imageUrl":["/images/benefit-section-2-2.png","/images/benefit-section-2-1.png"],"imageAlt":"pricing-package"}]},"Iv":{"title":"Selain Interaktif AI, Tersedia Kursus untuk Support Pembelajaranmu","description":"Percepat pengembangan keterampilanmu dengan kombinasi AI interaktif dan kursus dari Perusahaan dan Universitas top dunia."},"un":{"title":"Mulai Tingkatkan Bisnis dengan <strong class=\'text-violet_main\'>Learnext</strong>","description":"Cari tahu lebih lanjut mengenai Learnext business bersama tim sales kami. Integrasikan Learnext dengan cepat dan akses beragam kursus langsung di LMS Anda. "},"yt":{"title":"Kata mereka terkait Learnext","testimonies":[{"name":"Nehemya Lay","job":"GM HR Intera Group (Aquaproof)","title":"Meningkatkan skill lebih dari 1.000 karyawan Intera Group","body":"Sebagai perusahaan dengan lebih dari 1.000 karyawan, pengembangan SDM kami telah mendapatkan manfaat yang begitu baik dari Learnext. Kami lihat dari tingkat engagement yang sangat tinggi, dengan lebih dari 30% dari karyawan kami menyelesaikan berbagai kursus dalam topik seperti creative thinking, growth mindset, dan social intelligence. Learnext telah membantu kami mengadopsi pendekatan pembelajaran yang lebih dinamis di seluruh organisasi kami. Ini sangat membantu meningkatkan dan mengembangkan keterampilan dan produktivitas tim kami secara terukur dan berkesinambungan.","urlPeople":"https://staging-static.gokampus.com/course-institutions/jnwQGz3qleyUmovUXwd6QHQxW6C8CaDwoL0JvHa6.jpg","urlInstitution":"https://s.gokampus.com/business/logo-aquaproof.png"},{"name":"Faisal, S.ST.Par., MM.Par, CHE","job":"Kepala Pusat Pengembangan SDM, Kementerian Pariwisata dan Ekonomi Kreatif","title":"Merevolusi pengembangan skill ASN di Kemenparekraf","body":"Learnext telah merevolusi pendekatan kami terhadap pengembangan SDM. Dengan menawarkan beragam kursus yang memberdayakan ASN untuk mengadopsi pembelajaran mandiri. Perubahan ini tidak hanya untuk meningkatkan keterampilan ASN, tetapi juga dapat mewujudkan peserta pendidikan dan pelatihan yang lebih baik, sesuai dengan misi kami.","urlPeople":"https://staging-static.gokampus.com/course-institutions/nlYVDWBi8zlx71gPnYwl1TXtwbhAg6ODB2g0QN9N.jpg","urlInstitution":"https://s.gokampus.com/business/logo-wonderful-indonesia.png"},{"name":"Denanda Dewanto","job":"Human Capital Development Division Head of Boga Group","title":"Membantu tim di Boga Group tetap unggul","body":"Learnext telah mentransformasi tim kami, dengan kursus-kursus penting yang populer di antara karyawan kami seperti creative thinking, data analytics, dan personal growth. Hal ini mengembangkan keterampilan dan pengetahuan tim kami, yang akhirnya meningkatkan kemampuan tim dan tetap unggul dalam industri yang sangat kompetitif saat ini.","urlPeople":"https://staging-static.gokampus.com/course-institutions/ANiwfJsqcagv17YZ5U0LRCu1ublXnLfRiM0qv2EL.jpg","urlInstitution":"https://s.gokampus.com/business/logo-boga-red.png"}]},"NI":{"title":"Pilih Paket sesuai Kebutuhan Perusahaanmu","description":"Tentukan paket yang sesuai untuk perusahaanmu, mulai dari langganan tahunan atau bulanan.","packets":[{"label":"FITUR"},{"label":"ENTERPRISE","price":63000000,"price_after_discount":50000000,"price_certificate":63000000,"price_certificate_discount":50000000,"description":null,"benefits":["<strong>Unlimited learners - tanpa biaya per pengguna </strong>dalam satu entitas organisasi.","<strong>200 kursus</strong> (dapat diganti hingga 20 kursus per bulan), dengan serta sertifikat resmi dari mitra konten.","Konversi materi PPT internal menggunakan AI menjadi kursus digital (video, kuis, dan tugas) hingga <strong>total 1.000 menit</strong> durasi video.","<strong>Nexa, AI coach interaktif</strong> untuk semua pengguna hingga total durasi <strong>24.000 menit per tahun</strong> waktu diskusi. <br/> Upload file knowledge base perusahaan/organisasi untuk AI interaktif hingga <strong>10GB</strong> berbasis teks (dokumen tulisan, video bersuara, etc.), berbasis gambar (grafik, ilustrasi, etc.), maupun halaman website (url).","Dashboard data manager (visualisasi data standar)."],"selected":true,"tagline":"Paling Banyak Dipilih Perusahaan","button":"Coba Gratis","id":"price-enterprise"},{"label":"ULTIMATE","price":105000000,"price_after_discount":85000000,"price_certificate":105000000,"price_certificate_discount":85000000,"benefits":["<strong>Unlimited learners - tanpa biaya per pengguna </strong>dalam satu entitas organisasi.","<strong>Semua (1,000+) kursus</strong> (otomatis ditambah setiap minggu), dengan sertifikat resmi dari mitra konten dengan penyesuaian desain.","Konversi materi PPT internal menggunakan AI menjadi kursus digital (video, kuis, dan tugas) hingga <strong>total 5.000 menit</strong> durasi video.","<strong>Nexa, AI coach interaktif</strong> untuk semua pengguna hingga total durasi <strong>48.000 menit per tahun</strong> waktu diskusi. <br/> Upload file knowledge base perusahaan/organisasi untuk AI interaktif hingga <strong>20GB</strong> berbasis teks (dokumen tulisan, video bersuara, etc.), berbasis gambar (grafik, ilustrasi, etc.), maupun halaman website (url).","Dashboard data manager yang dapat disesuaikan kebutuhan visualisasi data."],"selected":false,"tagline":null,"button":"Coba Gratis","id":"price-enterprise-plus"}],"notes":["Semua harga tercantum belum termasuk PPN"],"premiumChapterWithFee":"Opsional & biaya tambahan","premiumChapterUnlimited":"Tanpa batas & tanpa biaya tambahan","newPacketsId":["","price-pro","price-enterprise","price-enterprise-plus"],"newPackets":[["Program Kursus Pilihan","50","1.000+","1.000+"],["Penggantian Program Kursus","1x sebulan","Update otomatis","Update otomatis"],["Jumlah Pelajar","Tidak terbatas","Tidak terbatas","Tidak terbatas"],["No charge per user","✅","✅","✅"],["Realtime Dashboard","✅","✅","✅"],["Premium Chapter dan Sertifikat","Opsional, biaya tambahan","Opsional, biaya tambahan","Tanpa batas & tanpa biaya tambahan"],["Customizable branding","-","-","✅"]]},"fG":{"title":"Solusi Terbaik Tingkatkan Bisnis Anda dengan <strong class=\'text-violet_main_to_dark_purple_surface\'>Learnext</strong> ","description":"Dapatkan seluruh manfaat Learnext","benefits":["Peningkatan Kompetensi Cerdas Berbasis AI","Konversi Materi Menjadi Video Kursus Interaktif","Fleksibel, Terintegrasi, dan Tanpa Batas Pengguna"],"institutionTitle":"Belajar dari perusahaan, universitas, dan trainer terkemuka.","contactSales":"Jadwalkan Demo","contactSalesDesc":"Tim Learnext siap membantu dan akan segera menghubungi Anda","fieldContactInput":"Masukkan no. handphone/email Anda","fieldContactPlaceholder":"08123456789 / example@mail.com","fieldContactHrisPlaceholder":"08123456789","fieldContactHrisInput":"Masukkan no. handphone Anda","fieldNameInput":"Masukan nama Anda","fieldCompanyInput":"Masukan nama perusahaan Anda","fieldNamePlaceholder":"John Doe","fieldCompanyPlaceholder":"PT ABC","fieldSubmit":"Kirim"},"MM":{"title":"Dapatkan Akses kursus di <strong class=\'text-violet_main_to_dark_purple_surface\'>Learnext</strong> dan <strong class=\'text-violet_main_to_dark_purple_surface\'>Kembangkan Karirmu!</strong>","description":"Bergabung dengan Learnext dan nikmati manfaat berikut:","benefits":["Akses tanpa batas ke ribuan kursus online yang dirancang oleh Perusahaan, Universitas dan Trainer Top Dunia","Jumlah pengguna tanpa batas dan tanpa biaya per pengguna","Manajemen proses pembelajaran dengan dashboard real-time"],"institutionTitle":"Belajar dari perusahaan, universitas, dan trainer terkemuka.","contactSales":"Gabung dengan Learnext","contactSalesDesc":"Bergabunglah dengan Learnext dan tingkatkan karir serta keterampilan Anda! Masukkan kontak di bawah ini dan tim kami akan segera membantu Anda.","fieldContactInput":"Masukkan no. handphone/email Anda","fieldContactHrisInput":"Masukkan no. handphone Anda","fieldSubmit":"Kirim"},"zx":{"viewDemo":"Lihat Demo","contactSales":"Jadwalkan Demo","courseTotal":"Total Kursus","partnerTotal":"Total Partner","learnerTotal":"Total Pelajar","scheduleDemo":"Jadwalkan Demo"},"Y1":{"TI":{"title":"Jelajahi & Pilih Kursus Untuk Perusahaanmu!","description":"Dengan Learnext, kamu dapat menjelajahi ribuan kursus dari institusi terpercaya langsung di LMS/HRIS perusahaanmu. Temukan dan pilih kursus-kursus terbaik yang sesuai dengan minat dan kebutuhan perusahaanmu.","stepper":["Pilih Kursus","Kirim daftar pilihan kursus","Dapatkan akses kursus langsung di LMS/HRIS perusahaanmu"]},"kA":{"form":{"title":"Lengkapi Informasi Perusahaan","description":"Sebelum mengirim kursus pilihanmu, pastikan untuk melengkapi informasi perusahaan dengan benar ya","dataForm":[{"label":"Nama Lengkap","placeholder":"Masukkan nama lengkap Anda","name":"name","value":"","required":true},{"label":"Email","placeholder":"nama@email.com","name":"email","value":"","required":true},{"label":"No Handphone","placeholder":"081234567890","name":"phone","value":"","required":true},{"label":"Versi Moodle","placeholder":"Pilih Versi Moodle","name":"platform_version","value":"","required":false}],"button":{"send":"Kirim Sekarang"}},"modal":{"success":{"title":"Hore! Kursus Pilihanmu Telah Terkirim","description":"Daftar kursus pilihanmu berhasil terkirim. Tim Learnext akan segera menghubungi kamu untuk membahas langkah selanjutnya.","button":"Kembali ke Homepage"}}}}}');

/***/ })

}]);